import { ReactComponent as InfoCircle } from 'assets/icons/InfoCircle.svg';
import React from 'react';

export default function BetaMigrationNotice() {
  return (
    <div className="mb-1 flex w-full flex-col gap-1 whitespace-normal rounded-md bg-[#EFF5FA] p-1.2">
      <InfoCircle className="text-primary-dark" />

      <p className="font-medium">The new VU.CITY Platform is here!</p>

      <p className="text-sm leading-5">
        Early access is now open. To request access, contact your organisation's admin or your Account Manager.
      </p>

      {/* <Link to="" rel="noreferrer" target="_blank">
        <Button variant="outlined" size="sm" fullWidth>
          Learn more
        </Button>
      </Link> */}
    </div>
  );
}
